import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../../components/ui/dialog';
import { cn } from '../../lib/utils';
import { BUTTON_MD, OUTLINE } from './discoveryClasses';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  pending?: boolean;
  confirmVariant?: 'default' | 'destructive';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  pending = false,
  confirmVariant = 'destructive',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !pending && onCancel()}>
      <DialogContent
        showCloseButton={false}
        className="w-[560px] gap-0 overflow-hidden rounded-2xl border-0 bg-white p-0 shadow-discovery-dialog sm:max-w-[560px]"
      >
        <div className="px-6 pt-5">
          <DialogTitle className="text-[18px] font-medium leading-[26px]">{title}</DialogTitle>
          <DialogDescription className="mt-1 text-[14px] text-foreground-muted">{body}</DialogDescription>
        </div>
        <div className="flex items-center gap-2 border-t border-stone-200 px-6 py-4">
          <span className="flex-1" />
          <Button variant="outline" className={cn(BUTTON_MD, OUTLINE)} disabled={pending} onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} className={BUTTON_MD} loading={pending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
